import { Injectable } from '@angular/core';
import { IQuotation } from 'shared-models';

/**
 * servizio che implementa il pattern consumabile
 * ovvero puoi storare un valore qui che una volta letto viene consumato
 * e non è più disponibile.
 */
@Injectable({ providedIn: 'root' })
export class ConsumableService {
	private _quotation: IQuotation | undefined = undefined;
	public get quotation() {
		const result = structuredClone(this._quotation);
		this._quotation = undefined; // consuma il valore
		return result;
	}
	public set quotation(value: IQuotation | undefined) {
		this._quotation = value;
	}

	private _imageUrl: string | undefined = undefined;
	public get imageUrl() {
		const result = this._imageUrl;
		this._imageUrl = undefined; // consuma il valore
		return result;
	}
	public set imageUrl(value: string | undefined) {
		this._imageUrl = value;
	}

	/**
	 * Scarta l'offerta da duplicare.
	 * Serve quando la navigazione verso quotation/new viene interrotta:
	 * NewQuotationComponent non viene creato e non consuma quotation, che resterebbe in memoria
	 * e la prossima nuova offerta si aprirebbe precompilata con quella.
	 */
	clear(): void {
		this._quotation = undefined;
		this._imageUrl = undefined;
	}
}
